<div class="IconsContainer">
    <div class="branddropdown"
        *ngIf="(isMultiSnapshot && (isFunnelChart || isPropellerChart)) || (isAudienceSnapshot && brandList.length>0 && alldata.length > 1 && (isFunnelChart || isPropellerChart))"
        (mouseleave)="isBrandListdropdownOpen=false">
        <button class="drop-toggle btn flat" (click)="toogleDropdown()">
            <span class="selectText"
                [title]="selectedBrand?selectedBrand:'Select'">{{selectedBrand ? cachedBrandDisplay : 'Select'}}</span>
            <p class="arrowicon"><img class="downarrow"
                    src="../../../../assets/ImagesSnapshot/Public/key-downDown.svg"></p>
        </button>
        <div class="additonal-drop-down" *ngIf="isBrandListdropdownOpen">
            <div class="item-container" *ngFor="let item of uniqueBrandList"
                [ngClass]="{'selected':item.checked}">
                <input type="radio" class="checkbox-radio" id="{{item.option}}"
                    (click)="checkBoxesbrandListClicked($event,item)" [checked]="item.checked">
                <label for="{{item.option}}" (click)="checkBoxesbrandListClicked($event,item)" class="checkbox-label"
                    [title]="item.option">{{(item.option)}}</label><br>
            </div>
        </div>
    </div>
    
    <div class="branddropdown"
        *ngIf="multimetricselect &&  (metricdropdownOutput && metricList.length>1) && _configService.selectedSnapshotType.toLowerCase().includes('multiple brands') && !isFunnelChart"
        (mouseleave)="isMetricDropdownOpen=false">
        <button class="drop-toggle btn flat" [ngClass]="{'many-widgets': alldata?.length > 5}" (click)="isMetricDropdownOpen=!isMetricDropdownOpen">
            <span class="selectText" [title]="selectedMetric || 'Select'">{{selectedMetric || 'Select'}}</span>
            <p class="arrowicon"><img class="downarrow" src="../../../../assets/ImagesSnapshot/Public/key-downDown.svg"></p>
        </button>
        <div class="additonal-drop-down" *ngIf="isMetricDropdownOpen" [ngClass]="{'many-widgets': alldata?.length > 5}">
            <div class="item-container" *ngFor="let item of metricList"
                [ngClass]="{'selected':item.checked}">
                <input type="radio" class="checkbox-radio" id="metric_{{item.option}}"
                    (click)="checkBoxesMetricListClicked($event,item)" [checked]="item.checked">
                <label for="metric_{{item.option}}" (click)="checkBoxesMetricListClicked($event,item)" class="checkbox-label"
                    [title]="item.option">{{item.option}}</label><br>
            </div>
        </div>
    </div>

    <div class="data-bars-toggle" *ngIf="data.widgetchart_name === 'Table' && EnableDatabar">
        <label>Data Bars</label>
        <div class="toggle-switch">
          <button [class.active]="data.enableDataBars" (click)="updateDataBars(data, true)">ON</button>
          <button [class.active]="!data.enableDataBars"  (click)="updateDataBars(data, false)">OFF</button>
        </div>
      </div>
    <div class="icons">
        <!-- item!=undefined && item.widgetchart_name=='FUNNEL CHART'" -->
        <!-- <div class="branddropdown"
            *ngIf="_configService.selectedSnapshotType.toLowerCase().includes('multi') && widgetchartname=='FUNNEL CHART' && brandList.length>0"
            (mouseleave)="isBrandListdropdownOpen=false">
            <button class="drop-toggle btn flat" (click)="toogleDropdown()">
                <span class="selectText"
                    [title]="selectedBrand?selectedBrand:'Select'">{{selectedBrand?getBrand():'Select'}}</span>
                <p class="fa fa-angle-down arrowicon"><img class="downarrow"
                        src="../../../../assets/ImagesSnapshot/Public/key-downDown.svg"></p>
            </button>
            <div class="additonal-drop-down" *ngIf="isBrandListdropdownOpen">
                <div class="item-container" *ngFor="let item of getUniqueBrand(brandList)" [ngClass]="{'selected':item.checked}">
                    <input type="radio" class="checkbox-radio" id="{{item.option}}"
                        (click)="checkBoxesbrandListClicked($event,item)" [checked]="item.checked">
                    <label for="{{item.option}}" (click)="checkBoxesbrandListClicked($event,item)"
                        class="checkbox-label" [title]="item.option">{{(item.option)}}</label><br>
                </div>
            </div>
        </div> -->


        <div class="icon"
            [ngClass]="data.sortingOrder == 0 ? 'icon-default' : data.sortingOrder == 1 ? 'icon-ascending' : 'icon-descending'    "
            *ngIf="isSortAvailable" (click)="onSortingClick('Sorting')"></div>
<div class="kpi-legend-btn-wrap"
     *ngIf="widgetchartname === 'Vertical Stack Bar' || widgetchartname === 'Horizontal Stack Bar' || ((widgetchartname === '05/PIE CHART' || widgetchartname === '01/PIE CHART' || widgetchartname === '09/PIE CHART') && isAudienceSnapshot && isMultiOrCohort)"
     style="position:relative;">
<button
  class="kpi-legend-btn"
  [disabled]="isDisabled"
  [ngClass]="{'disabled-btn': isDisabled}"
  (click)="isDisabled ? null : toggleLegendDropdown($event)">
  Legend
</button>
<div class="kpi-legend-dropdown" [class.kpi-legend-dropdown--table]="legendTable" *ngIf="legendDropdownOpen">
        <table class="kpi-legend-table" *ngIf="legendTable">
            <thead>
                <tr>
                    <th></th>
                    <th *ngFor="let cohort of legendTable.cohorts" [title]="cohort"><span class="kpi-legend-cohort-label">{{ cohort }}</span></th>
                </tr>
            </thead>
            <tbody>
                <tr class="kpi-legend-row" *ngFor="let row of legendTable.rows">
                    <td class="kpi-legend-row-label">
                        <span class="kpi-legend-dot" [style.background]="row.color"></span>
                        <span class="kpi-legend-label" [title]="row.name">{{ row.name }}</span>
                    </td>
                    <td *ngFor="let cohort of legendTable.cohorts">{{ row.values[cohort] }}</td>
                </tr>
            </tbody>
        </table>
        <ng-container *ngIf="!legendTable">
            <div class="kpi-legend-item"
                 [class.kpi-legend-item--hidden]="hiddenSeriesMap[leg.name]"
                 [class.kpi-legend-item--kpi]="leg.isKPI"
                 (click)="toggleSeries(leg, $event)"
                 *ngFor="let leg of legendItems">
                <span class="kpi-legend-dot"
                      [class.kpi-legend-dot--kpi]="leg.isKPI"
                      [style.background]="leg.isKPI ? '#9e9e9e' : leg.color"></span>
                <span class="kpi-legend-label" [class.kpi-legend-label--kpi]="leg.isKPI" [title]="leg.name">{{ leg.name }}</span>
            </div>
        </ng-container>
    </div>
</div>
<div class="cluster-legend-btn-wrap"
     *ngIf="widgetchartname === 'Vertical Cluster Bar' || widgetchartname === 'Horizontal Cluster Bar'"
     style="position:relative;">
  <button
  class="kpi-legend-btn"
  [disabled]="isDisabled"
  [ngClass]="{'disabled-btn': isDisabled}"
  (click)="isDisabled ? null : toggleClusterLegendDropdown($event)">
  Legend
</button>
  <div class="cluster-legend-dropdown" *ngIf="clusterLegendDropdownOpen">
    <div class="kpi-legend-item"
         *ngFor="let leg of legendItems"
         [class.kpi-legend-item--hidden]="hiddenSeriesMap[leg.name]"
         (click)="toggleSeries(leg, $event)">
      <span class="kpi-legend-dot" [style.background]="leg.color"></span>
      <span class="kpi-legend-label" [title]="leg.name">{{ leg.name }}</span>
    </div>
  </div>
</div>
        <div *ngIf="isSingleFunnelOrMultipleWidget && !isSingleFunnel"  alt="" class="icon icon-expand" (click)="showExpandPopupFun()">
        </div>
        <!-- src="../../../../../assets/images/common/Icon_more.svg" -->
        <!-- LengthOf(customization?.additionalGroup)<1 -->
         
        <div alt=""   class="icon icon-more" *ngIf="additionalGroupLength > 0"
            (click)="additionalGroupLength > 0 ? showelementlist() : null"></div>
        <div class="elementList" *ngIf="data.showElementList && additionalGroupLength > 0"
            DocumentClick (DocumentClicked)="closeelementList()" #elementList>
            <!-- {{data.elementList | json}} -->
            <div *ngFor="let item of data.elementList" class="element" [ngClass]="{'selected':item.selected}"
                (click)="elementItemSelect(item,elementList,'')">
                <div class="elementLabel" *ngIf="item.item != 'Sorting'">
                    <div class="elementitem">{{item.item}}</div>
                    <div class="rightarrow" *ngIf="item.options && item.options.length>0"></div>
                </div>
                <!-- (click)="toggleDropdown1($event, dropdownContainer)" -->
                <div class="dropdown" #dropdownContainer *ngIf="item.isdropDown" DocumentClick
                    (DocumentClicked)="closedropdown(item)">
                    <div *ngFor="let item1 of dropDownItems" class="element" [ngClass]="{'selected':item1.selected}"
                        (click)="dropDownSelect(item1)">
                        <div class="elementitem">
                            <input class="cursor" type="radio" [id]="item1.item" (click)="dropDownSelect(item1)"
                                [checked]="item1.selected">
                            <label class="cursor" [style]="item1.selected?'color:rgba(128, 41, 182, 1)':'color:black'"
                                for="item1.item" (click)="dropDownSelect(item1)">{{item1.item}}</label>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- <div class="dropdown" *ngIf="isdropDown" DocumentClick (DocumentClicked)="closedropdown()">
            <div *ngFor="let item of dropDownItems" class="element" [ngClass]="{'selected':item.selected}"
                (click)="dropDownSelect(item)">
                <div class="elementitem">{{item.item}}</div>
            </div> -->
        <!-- </div> -->
    </div>
</div>
<!-- <div *ngIf="showExpandPopup || (_configService.selectedSnapshotType.toLowerCase().includes('multi') && widgetchartname!='FUNNEL CHART')"> -->
<div
    *ngIf="(showExpandPopup && !(isMultiOrCohort && (isFunnelChart || isPropellerChart))) || 
             (isMultiOrCohort && !(isFunnelChart || isPropellerChart))">
    <div class="overlay" *ngIf="showExpandPopup"></div>
    <app-output-popup *ngIf="showExpandPopup" [id]="id + 1000"  [snapProduct]="'custom'" [popUpParameter]="cachedPopupWidgetName"
        [customData]="data" (dataEventCustom)="receivedDeleteConfirmation($event)"></app-output-popup>
</div>

<div
    *ngIf="showExpandPopup && (isMultiOrCohort && (isFunnelChart || isPropellerChart))">
    <div class="overlay" *ngIf="showExpandPopup"></div>
    <app-output-popup *ngIf="showExpandPopup" [id]="id + 1000" [multiFunnelPopup]="showExpandPopup" [snapProduct]="'custom'"
        [popUpParameter]="data.widget_name" [customData]="data"
        (dataEventCustom)="receivedDeleteConfirmation($event)"></app-output-popup>
</div>

<app-shared-popup-snapshot *ngIf="infoClicked"  [popUpParameter]="infoTextTitle" [infoheaderTitle]="infoTextTitle"
    [popUpMessage]="infoTextMessage" (closeErrorPopUp)="onCloseIconClick($event)" [showErrorPopUp]="false"
    [showInputPopUp]="true"></app-shared-popup-snapshot>

<div *ngIf="showTrendPoppup">
    <div class="overlay"></div>
    <app-output-popup *ngIf="showTrendPoppup" [popUpParameter]="cachedPopupWidgetName" [snapProduct]="'custom'"
        [visualization]="'Line Chart'" [metricList]="metricLists" [brandList]="brandLists" [trendLineView]="trendlineOutputView" [initialMetric]="selectedMetric" [id]="id" [customData]="trendData" [item]="item"
        
        (dataEventTrend)="hide($event)"></app-output-popup>
    <!-- [DataLabelOn]="DataLabelOn" [Top10Toggle]="Top10Toggle"  [trendData]="data" [id]="id" [height]="height" -->
</div>